import RetailModal from './RetailModal.svelte';


!customElements.get('retail-modal') && customElements.define('retail-modal', RetailModal);
export default RetailModal;
